import axios from 'axios'
import {config} from '../config'
export const getmapData = () =>{
    return axios.get(config.mapdata)
    .then(function (response) {
        return response
    })
    .catch(function (error) {
      console.log(error);
    })
}

